export default [
    {
        key: 'ManualInvoiceImportModal',
        getComponent: function () { return import('./ManualInvoiceImportModal'); },
        width: 600,
        title: i18n.get('发票导入设置下发'),
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
